/**
 * Layout pour le panel admin
 * Sidebar fixe a gauche + zone de contenu avec Outlet
 *
 * Securite:
 * - Timeout d'inactivite de 30 minutes (donnees sensibles)
 */

import { Outlet } from 'react-router-dom';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { useInactivityTimeout } from '@/hooks/useInactivityTimeout';

export default function AdminLayout() {
  // Securite: deconnexion automatique apres 30 minutes d'inactivite
  useInactivityTimeout({
    timeoutMinutes: 30,
    enabled: true
  });

  return (
    <div className="min-h-screen flex bg-slate-50">
      {/* Sidebar fixe */}
      <AdminSidebar />

      {/* Zone de contenu */}
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
}
